import { BaseAppointmentProps, QueueSetupStep } from 'models/appointment.types';

export type QueueVisit = Pick<
  BaseAppointmentProps,
  'careProvider' | 'category' | 'hasStaffJoined' | 'modalityType' | 'queueEstimate' | 'steadymd'
>;

/**
 * LifeMD on-demand visits are queue visits that SteadyMD is not servicing.
 * SteadyMD keeps the lobby it has today.
 */
export const isLifeMdOnDemandVisit = (appointment?: null | QueueVisit): boolean => {
  if (!appointment) return false;
  const isQueue = appointment.category === 'queue' || appointment.modalityType === 'sync_queue';
  if (!isQueue || appointment.steadymd || appointment.careProvider === 'SteadyMD') return false;
  return appointment.careProvider === 'LifeMD' || !!appointment.queueEstimate;
};

/** Hide reschedule once a LifeMD provider has joined. SteadyMD keeps its button. */
export const shouldHideQueueReschedule = (appointment?: null | QueueVisit): boolean =>
  !!appointment?.hasStaffJoined && isLifeMdOnDemandVisit(appointment);

/** Setup still required before an on-hold LifeMD visit joins the line, or null when none is sent. */
export const getQueueSetupSteps = (appointment?: null | QueueVisit): null | QueueSetupStep[] => {
  if (!isLifeMdOnDemandVisit(appointment)) return null;
  const estimate = appointment?.queueEstimate;
  if (estimate?.state !== 'on_hold' || !estimate.setupSteps?.length) return null;
  return estimate.setupSteps;
};
